import { Link } from "react-router-dom";
import { relatedTitles } from "@/mocks/relatedTitles";

export default function RelatedTitles() {
  return (
    <div className="rounded-lg bg-background-100 border border-background-200/70 p-4">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-heading text-sm tracking-wide text-foreground-950">
          相关推荐
        </h3>
        <span className="text-[10px] px-2 h-5 rounded-full bg-secondary-100 text-secondary-900 flex items-center">
          演示内容
        </span>
      </div>
      <ul className="space-y-3">
        {relatedTitles.map((item) => (
          <li key={item.id}>
            <Link
              to="/about"
              className="group flex gap-3 rounded-md p-1.5 hover:bg-background-200/50 transition-colors cursor-pointer"
            >
              <div className="w-[52px] h-[74px] shrink-0 rounded overflow-hidden bg-background-900">
                <img
                  src={item.cover}
                  alt={item.title}
                  title={`${item.title} 同类题材推荐`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-1.5">
                  <span className="text-[10px] text-accent-500">{item.badge}</span>
                </div>
                <h4 className="text-xs font-medium text-foreground-900 mt-0.5 line-clamp-1">
                  {item.title}
                </h4>
                <p className="text-[10px] text-foreground-600 mt-0.5">{item.genre}</p>
              </div>
            </Link>
          </li>
        ))}
      </ul>
      <p className="mt-3 pt-3 border-t border-background-200/70 text-[11px] leading-5 text-foreground-600">
        以上为排版演示用的推荐位，本站内容仅聚焦「朋友的妈妈4」。
      </p>
    </div>
  );
}